//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import angular, { IHttpInterceptor, IQService, IRequestConfig } from 'angular';
import { Auth } from 'aws-amplify';

import { CuralateAuthTokenHeader } from '@utils/sessionFetch';

async function getJwtToken() {
  try {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
  } catch (e) {
    return undefined;
  }
}

class CognitoTokenInterceptor implements IHttpInterceptor {
  constructor(private readonly $q: IQService) {}

  // HTTP request interceptor: Called when a request is made (pre-request)
  public request = (config: IRequestConfig) => {
    // Don't add jwt to every request, only local ones
    if (!config.url.startsWith('/api/')) {
      return config;
    }
    return this.$q.when(
      getJwtToken().then((jwt) => {
        if (jwt) {
          config.headers = {
            ...config.headers,
            [CuralateAuthTokenHeader]: jwt,
          };
        }
        return config;
      }),
    );
  };
}

angular
  .module('curalate')
  .service('cognitoTokenInterceptor', ['$q', CognitoTokenInterceptor]);
